















import { Component, Ref, Vue } from "vue-property-decorator";
import AuditCount from "@/views/myAudit/components/AuditCount.vue";
import AuditTabOfOrganizationUnit from "@/views/myAudit/tabs/tabOrganizationUnit.vue";

@Component({
  name: "AuditTabOrganization",
  components: {
    AuditTabOfOrganizationUnit,
    AuditCount,
  },
})
export default class AuditTabTrain extends Vue {
  countDic: any = {
    "organizationUnit":0,
  };
  totalCount = 0;

  handleCountChange(target: string, $event: number) {
    this.countDic[target] = $event;
    this.totalCount += $event;
    this.$emit("count-changed", ["organizationUnit", this.totalCount]);
  }

  hasAuditPermission(permissionCode: string) {
    return this.hasPermission(permissionCode);
  }
}
